export const BRANDS = ["Youngness Center", "Awish Clinic", "Both"];

export const GOAL_CATEGORIES = ["New Service Launch", "Tech Acquisition", "Quality/Safety Upgrade", "Ingredient Sourcing", "Revenue Impact"];
export const GOAL_STATUS = ["On Track", "At Risk", "Behind", "Completed", "Deferred"];
export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const IDEA_CATEGORIES = ["Device/Machine", "Clinical Service", "Cosmetic/Formulation", "Biotech/Paper", "Digital/Software"];
export const STAGES = [
  { key: "Discovery", label: "Discovery / Inbox", icon: "📥" },
  { key: "Validation", label: "Under Validation", icon: "🔬" },
  { key: "Feasibility", label: "Feasibility", icon: "🧪" },
  { key: "Approved", label: "Approved", icon: "✅" },
  { key: "Rollout", label: "In Rollout", icon: "🚀" },
];
export const REJECTION_REASONS = ["High Cost", "Low Efficacy", "Regulatory Issue", "Irrelevant"];

export const STATUS_COLORS = {
  "On Track": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "At Risk": "bg-amber-100 text-amber-700 border-amber-200",
  "Behind": "bg-red-100 text-red-700 border-red-200",
  "Completed": "bg-sky-100 text-sky-700 border-sky-200",
  "Deferred": "bg-slate-100 text-slate-600 border-slate-200",
};

export const STAGE_COLORS = {
  Discovery: "border-t-slate-400",
  Validation: "border-t-secondary",
  Feasibility: "border-t-violet-500",
  Approved: "border-t-primary",
  Rollout: "border-t-emerald-600",
};
